export default __webpack_public_path__ + "static/media/HeroHuntIcon.58dda8b2.svg";